'use client';

import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
export function Dropdown(props) {
  const $ = _c(2);
  const t0 = props as Headless.MenuProps<'div'>;
  let t1;
  if ($[0] !== t0) {
    t1 = <Headless.Menu {...t0} />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}